import * as forge from 'node-forge';
import { environment } from '../../environments/environment.prod';

export function encrypt(plainText: string): string {
  const key = environment.publicKey;
  const publicKey = forge.pki.publicKeyFromPem(key);
  const encrypted = publicKey.encrypt(plainText, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
  });
  return forge.util.encode64(encrypted);
}
